import CategoryModel from "@/models/CategoryModel";
export default class FilterModel {
  sortby: string | null;
  datestart: string | null;
  dateend: string | null;
  urgency: string | null;
  categories: CategoryModel[];
  wocode: string | null;
  constructor() {
    this.sortby = null;
    this.datestart = null;
    this.dateend = null;
    this.urgency = null;
    this.categories = [];
    this.wocode = null;
  }
}
